import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import '@/index.css'
import { Route, Routes } from 'react-router-dom'
import { appRoutes } from './constants.js'
import { ScrollToTop } from './components/ScrollToTop.js'
import QuestLoader from './components/QuestLoader.js'

import Home from '@/views/Home.js'

const NotFound = React.lazy(() => import('@/views/NotFound.js'))
const HowItWorks = React.lazy(() => import('./views/HowItWorks.js'))
const ContactUsPage = React.lazy(() => import('./views/Contact.js'))
const PrivacyPolicy = React.lazy(() => import('./views/PrivacyPolicy.js'))
const TermsOfService = React.lazy(() => import('./views/TermsOfService.js'))

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<QuestLoader />}>
        <Routes>
          <Route path={appRoutes.home}>
            <Route index path={appRoutes.home} element={<Home />} />
            <Route path={appRoutes.howItWorks} element={<HowItWorks />} />
            <Route path={appRoutes.authenticator} />
            <Route path={appRoutes.contact} element={<ContactUsPage />} />
            <Route path={appRoutes.privacyPolicy} element={<PrivacyPolicy />} />
            <Route
              path={appRoutes.termsOfService}
              element={<TermsOfService />}
            />
            <Route path={appRoutes.notFound} element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  )
}

const App = () => {
  return (
    <BrowserRouter basename="/">
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App
